export default __webpack_public_path__ + "static/relationship_brainstorm-3b003fd713917078e3d1d72d5c078bf2.png";